export default {
  id: 4,
  adminOnly: false,
  type: "disciplines",
  title: "Asignaturas",
  deleteEntriesAllowed: true,
  actions: {
    get: "getDisciplines",
    post: "postDiscipline",
    patch: "patchDiscipline",
    delete: "deleteDiscipline",
  },
  headers: [
    {
      title: "Descripción",
      field: {
        name: "descripcion",
        type: "select",
        multiple: false,
        options: "disciplines",
        optionName: "descripcion",
        editable: true,
      },
    },
    {
      title: "ID Curso",
      field: {
        name: "ID_Curso",
        type: "select",
        multiple: false,
        options: "courses",
        optionName: "ID_Curso",
        editable: false,
      },
    },
    {
      title: "Profesores",
      field: {
        name: "profesores",
        type: "select",
        multiple: true,
        options: "teachers",
        optionName: "ID_Instructor",
        editable: true,
      },
    },
  ],
  options: [],
  filters: [
    {
      title: "Descripción",
      name: "descripcion",
      type: "select",
      fromExtras: true,
      options: "disciplines_distinct",
      optionName: "descripcion",
    },
    {
      title: "ID Curso",
      name: "ID_Curso",
      type: "select",
      fromExtras: true,
      options: "courses_distinct",
      optionName: "ID_Curso",
    },
  ],
};
